import capitalize from 'lodash/capitalize';
import compose from 'lodash/fp/compose';
import reverse from 'lodash/fp/reverse';
import sortBy from 'lodash/fp/sortBy';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';

import { SPECIALTY } from 'common/constants';

import CONFIG from '../../../../app.config';

export const formatPhoneNumber = phoneNumber => {
  if (!phoneNumber) {
    return phoneNumber;
  }

  const phoneString = phoneNumber.toString();
  return `(${phoneString.substring(2, 5)})
  ${phoneString.substring(5, 8)}-${phoneString.substring(8, 12)}`;
};

const capitalizeReducer = (accumulator, currentValue) =>
  `${accumulator}, ${capitalize(currentValue)}`;
export const formatSpecificAvailabilities = specificAvailabilities =>
  specificAvailabilities
    .slice(1)
    .reduce(capitalizeReducer, capitalize(specificAvailabilities[0]));

const findDefaultOfferedAppointmentType = (
  offeredAppointmentTypes,
  specialtyId,
  ignoreSpecialty,
) => {
  let defaultTypes = offeredAppointmentTypes.filter(
    offeredAppointmentType =>
      get(offeredAppointmentType, 'appointmentType.name', '').toLowerCase()
      === 'initial visit'
      && get(offeredAppointmentType, 'appointmentType.specialty.id')
      === specialtyId,
  );

  // If empty, default explicitly to initial dentist appointment
  if (isEmpty(defaultTypes) && ignoreSpecialty) {
    defaultTypes = offeredAppointmentTypes.filter(
      offeredAppointmentType =>
        get(
          offeredAppointmentType,
          'appointmentType.name',
          '',
        ).toLowerCase() === 'initial visit'
        && get(offeredAppointmentType, 'appointmentType.specialty.id')
        === SPECIALTY.dentist,
    );
  }

  if (!isEmpty(defaultTypes)) {
    return compose(
      sortBy('duration'),
      reverse,
    )(defaultTypes)[0];
  }
  // TODO from search v1: This hack is needed to let a patient book an appointment at least with some type.
  return compose(
    sortBy('duration'),
    reverse,
  )[0];
};

export const getOfferedAppointmentType = (provider, specialtyId) => {
  const offeredAppointmentTypes = provider?.offeredAppointmentTypes || [];
  return findDefaultOfferedAppointmentType(
    offeredAppointmentTypes,
    specialtyId,
    true,
  );
};

export const getPatientAppUrl = appointmentId =>
  `${
    CONFIG.PATIENT_APP_URL
  }/#/appointment/${appointmentId}/?source=Recommendations&walkthrough=true`;

export const getVerificationData = (
  patient,
  requestedAppointment,
  matchId,
  match,
) => {
  const doctor = get(requestedAppointment, 'provider.doctor');

  const data = {};
  if (get(patient, 'metadata.primaryInsuranceMember') === false) {
    data.firstName = get(patient, 'metadata.memberFirstName');
    data.lastName = get(patient, 'metadata.memberLastName');
    data.dob = get(patient, 'metadata.memberDateOfBirth');
  } else {
    data.firstName = get(patient, 'firstName');
    data.lastName = get(patient, 'lastName');
    data.dob = get(patient, 'dateOfBirth');
  }

  data.insuranceProviderName = get(match, 'other.insurance.provider');
  data.insuranceProviderState = get(
    patient,
    'metadata.wizardData.location.address.administrative_area_level_1',
  );
  data.matchId = matchId;
  data.npi = doctor ? doctor.npi : undefined;
  data.memberId = get(patient, 'metadata.wizardData.insurance.memberId');

  return data;
};
